import React, { Component } from 'react';
import { IReducerState } from '../../../states/renditionStates';
import { connect } from 'react-redux';
import ModalPopup from '../../../modalrelated/modalPopup';
import NormalScreenPopup from '../../../modalrelated/normalScreenPopup';
import { RSCH_HTML_TRACKING_CONFIG } from '../../../readership/trackingConfig';
import { enterKeyPressed } from '../../../utils/general/enterKey';
import IFramePage from './../../../containers/innerPagePart/iframePage';
import RenditionUrlGenerator from "../../../utils/api/renditionUrlGenerator";
import $ from 'jquery';
import { isEmpty, isEqual } from 'lodash';
import { addParam, base64urlEncode } from '../../../utils/general/general';
import { getStaticEPFAccessToken } from '../../../utils/general/EpfTokensUtils';
interface IHouseViewProps {
    docHeaderSectionJson: {
        i18n: {
            houseViews: string
        }
    };
    isExternalUser?: boolean;
    menuCode: any;
}

interface IHouseViewStatus {
    modalStatus: boolean;
}
const HOUSE_VIEWS_URL = "/cvr/citiresearchui/eppublic/pure/mfp/Overview?pageheader=false";
export class HouseView extends Component<IHouseViewProps, IHouseViewStatus> {
    constructor(props: IHouseViewProps) {
        super(props);
        this.state = {
            modalStatus: false,
        };
    }

    public openModal(e: any) {
        if (e.target.id === "modalClose") {
            this.setState({
                modalStatus: false,
            });
            $('.triggered_popup_flag').focus().removeClass('triggered_popup_flag');
        } else if (this.state.modalStatus === false) {
            this.setState({
                modalStatus: true,
            });
            e.target.className += " triggered_popup_flag";
            RSCH_HTML_TRACKING_CONFIG.trackFinancialsHouseViews();
        }
    }

    public render() {
        const environment = window.HTML_RENDITION.initialData.environment;
        const {docHeaderSectionJson, isExternalUser, menuCode} = this.props;
        const houseViewsLabel = docHeaderSectionJson.i18n.houseViews;
        // const houseViewUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + HOUSE_VIEWS_URL + '&popup=true';
        // const houseViewDetachUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + HOUSE_VIEWS_URL + `&detachTitle=${encodeURIComponent(docHeaderSectionJson.i18n.houseViews)}&pageTitle=${encodeURIComponent(document.title)}`;
        let houseViewBaseUrl = "cvr/citiresearchui/eppublic/mfp/Overview";
        let houseViewPureBaseUrl = "cvr/citiresearchui/eppublic/pure/mfp/Overview";
        const epfToken =  getStaticEPFAccessToken();
        if (!isEmpty(epfToken)) {
            houseViewBaseUrl = addParam(houseViewBaseUrl, '__epftoken', epfToken);
            houseViewPureBaseUrl = addParam(houseViewPureBaseUrl, '__epftoken', epfToken);
        }
        let houseViewUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + '/cv2/smartlink/menu/RSCH_LANDING_PAGE?U0xfNjQ.' + btoa('urlOverride=' + encodeURIComponent("/" + houseViewBaseUrl));
        if (isExternalUser) {
            houseViewUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + "/" + houseViewPureBaseUrl;
        } else if (!isEmpty(menuCode) && !isEqual(menuCode, 'RSCH_LANDING_PAGE')) {
            houseViewUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + `/cv2/go/${menuCode}/` +base64urlEncode(`__NAVIGATION_BASE64__${houseViewPureBaseUrl}`);     
            const epfTokenFrameUrl =  getStaticEPFAccessToken();
            if (!isEmpty(epfTokenFrameUrl)) {
                houseViewUrl = houseViewUrl + `?__epftoken=${epfTokenFrameUrl}`;
            }  
        }
        // const _modalSource = (
        //   <IFramePage
        //      iframePageUrl={houseViewUrl}
        //      currentPage="HouseViews"
        //      iframeId="iframe-houseViews"
        //      iframeStyle={{minWidth: '600px'}}
        //      iframeHolderStyle={{minWidth: '600px'}}
        //      customScrollingOption="yes"
        //    />);
        return (
            <React.Fragment>
                <div 
                className="financials" 
                // onClick={(e) => this.openModal(e)} 
                // onKeyPress={(e) => enterKeyPressed(e, this.openModal.bind(this, e))}
                onKeyPress={() => window.open(houseViewUrl, isExternalUser ? "_self" : "_blank")}
                onClick={() =>{                     
                    RSCH_HTML_TRACKING_CONFIG.trackFinancialsHouseViews();
                    window.open(houseViewUrl, isExternalUser ? "_self" : "_blank")}}
                >
                    {/* {this.state.modalStatus &&
                        <ModalPopup classList={'modal-house-views'}>
                            <NormalScreenPopup
                                titleSource={docHeaderSectionJson.i18n.houseViews}
                                bodySource={_modalSource}
                                modalWindowStyle={{width:'1000px',height: '650px', maxHeight: '650px', maxWidth: '1000px'}}
                                openDetachURL={'true'}
                                modalClass='houseviews-modal'
                                customDetachURL={houseViewDetachUrl}
                                isIframeContent
                            />
                        </ModalPopup>} */}
                    {/* <span className="icon-house-views icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.houseViews} /> */}
                    <span className='icon-svg-parent'>
                        <span className=" icon-svg icon-house-views-svg" role="img" aria-label={houseViewsLabel} />
                    </span>
                    <a tabIndex={0} aria-label={houseViewsLabel} role="button" id="financials-houseviews" className="x-rsch-hyperlink">{houseViewsLabel}</a>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        menuCode: state.commonStateReducer.menuCode,
    };
};

export default connect(mapStateToProps)(HouseView);
